// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPaymentAccountResponseDto
 */
export interface IPaymentAccountResponseDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IPaymentAccountResponseDto
     */
    payment_ids?: Array<number>;
}

/**
 * Check if a given object implements the IPaymentAccountResponseDto interface.
 */
export function instanceOfIPaymentAccountResponseDto(value: object): value is IPaymentAccountResponseDto {
    return true;
}

export function IPaymentAccountResponseDtoFromJSON(json: any): IPaymentAccountResponseDto {
    return IPaymentAccountResponseDtoFromJSONTyped(json, false);
}

export function IPaymentAccountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentAccountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_ids': json['payment_ids'] == null ? undefined : json['payment_ids'],
    };
}

export function IPaymentAccountResponseDtoToJSON(json: any): IPaymentAccountResponseDto {
    return IPaymentAccountResponseDtoToJSONTyped(json, false);
}

export function IPaymentAccountResponseDtoToJSONTyped(value?: IPaymentAccountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_ids': value['payment_ids'],
    };
}

